export {default} from './AirbnbRedirectVerificationProcedure';



// WEBPACK FOOTER //
// ./src/containers/AirbnbRedirectVerificationProcedure/index.ts